import { render } from "./SizeDrop.vue?vue&type=template&id=e58443e0"
import script from "./SizeDrop.vue?vue&type=script&lang=js"
export * from "./SizeDrop.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__